export var PhoneStatusTypes;
(function (PhoneStatusTypes) {
    PhoneStatusTypes["CONNECTING"] = "CONNECTING";
    PhoneStatusTypes["CONNECTED"] = "CONNECTED";
    PhoneStatusTypes["DISCONNECTED"] = "DISCONNECTED";
    PhoneStatusTypes["REGISTERING"] = "REGISTERING";
    PhoneStatusTypes["REGISTERED"] = "REGISTERED";
    PhoneStatusTypes["UNREGISTERED"] = "UNREGISTERED";
    PhoneStatusTypes["TERMINATED"] = "TERMINATED";
})(PhoneStatusTypes || (PhoneStatusTypes = {}));
export var CallStatusTypes;
(function (CallStatusTypes) {
    CallStatusTypes["PRECONNECT"] = "PRECONNECT";
    CallStatusTypes["INITIATING"] = "INITIATING";
    CallStatusTypes["RINGING"] = "RINGING";
    CallStatusTypes["ANSWERED"] = "ANSWERED";
    CallStatusTypes["TERMINATED"] = "TERMINATED";
    CallStatusTypes["ON_HOLD"] = "ON_HOLD";
})(CallStatusTypes || (CallStatusTypes = {}));
export var ConferenceTypes;
(function (ConferenceTypes) {
    ConferenceTypes[ConferenceTypes["CALL"] = 1] = "CALL";
    ConferenceTypes[ConferenceTypes["USER"] = 2] = "USER";
})(ConferenceTypes || (ConferenceTypes = {}));
export var Events;
(function (Events) {
    Events["PHONE_STATUS"] = "phone:status";
    Events["CALL_STATUS"] = "call:status";
    Events["CONFERENCE_JOINING"] = "conference:joining";
    Events["CONFERENCE_LEAVING"] = "conference:leaving";
})(Events || (Events = {}));
export var SpyTypes;
(function (SpyTypes) {
    SpyTypes["LISTEN"] = "LISTEN";
    SpyTypes["WHISPER"] = "WHISPER";
    SpyTypes["BARGE"] = "BARGE";
})(SpyTypes || (SpyTypes = {}));
export var CallType;
(function (CallType) {
    CallType["inboundCalls"] = "inboundCalls";
    CallType["campaignListCalls"] = "campaignListCalls";
    CallType["customCalls"] = "customCalls";
})(CallType || (CallType = {}));
